import DropdownRoot from './Root';
import DropdownTrigger from './Trigger';
import DropdownContainer from './Container';
import DropdownHeader from './Header';
import DropdownBody from './Body';
import DropdownFooter from './Footer';
import DropdownRow from './Row';

export const Dropdown = {
  Root: DropdownRoot,
  Trigger: DropdownTrigger,
  Container: DropdownContainer,
  Header: DropdownHeader,
  Body: DropdownBody,
  Footer: DropdownFooter,
  Row: DropdownRow,
};
